import React from "react";
import { FormControlLabel, Radio, FormHelperText } from "@material-ui/core";
import { Field, useFormikContext } from "formik";
import { RadioGroup, Checkbox } from "formik-material-ui";

const ResignNauticalBlueText = ({ disableAll }) => {
  const { errors, touched, values, initialValues } = useFormikContext();
  const radioPropsValueTwo = {
    checked: initialValues?.sintaksiouxos_afora === 1,
  };
  const radioPropsValueThree = {
    checked: initialValues?.reason_for_copy_nautical_issue === 2,
  };

  const tableWithLabels = [
    {
      value: "1",
      label:
        "2.Είμαι συνταξιούχος  φορέα ενταχθέντος στον Ενιαίο Φορέα Κοινωνικής  Ασφάλισης (Ε.Φ.Κ.Α.) ή έτερου δημοσίου ασφαλιστικού φορέα (π.δ. 104/2020).",
    },
    {
      value: "2",
      label:
        "3.Δεν είμαι συνταξιούχος  φορέα ενταχθέντος στον Ενιαίο Φορέα Κοινωνικής  Ασφάλισης (Ε.Φ.Κ.Α.) ή έτερου δημοσίου ασφαλιστικού φορέα (π.δ.104/2020).",
    },
  ];
  return (
    <div>
      <p className="underline text-base font-bold">
        AITHΣΗ ΕΠΑΝΑΠΟΓΡΑΦΗΣ ΜΠΛΕ (Π.Δ. 104/2020)
      </p>
      <br></br>
      <p className="text-base font-bold">
        Σας υποβάλλω σχετικά δικαιολογητικά και παρακαλώ όπως προβείτε στην
        επαναπογραφή ναυτικού φυλλαδίου. Με ατομική μου ευθύνη και γνωρίζοντας
        τις κυρώσεις, που προβλέπονται από τις διατάξεις της παρ. 6 του άρθρου
        22 του Ν. 1599/1986, σας δηλώνω υπεύθυνα ότι:
      </p>
      <br></br>
      <br></br>
      <p className="text-base font-bold">
        1.Δεν έχω την ιδιότητα του πολιτικού υπαλλήλου (Μόνιμου - Ι.Δ.Α.Χ.) του
        Δημοσίου, Νομικού Προσώπου Δημοσίου Δικαίου (Ν.Π.Δ.Δ.), των Οργανισμών
        Τοπικής Αυτοδιοίκησης (Ο.Τ.Α.) πρώτου και δευτέρου βαθμού ή στρατιωτικού
        υπαλλήλου (π.δ. 104/2020).
      </p>
      <br></br>
      {errors["sintaksiouxos_afora"] && touched["sintaksiouxos_afora"] && (
        <FormHelperText className="text-xl text-error border-l-2 border-error pl-1">
          Επιλέξτε μία από τις δύο επιλογές
        </FormHelperText>
      )}
      {tableWithLabels.map((item) => {
        return (
          <label key={item.value} className="p-2 flex">
            <Field
              type="radio"
              name="sintaksiouxos_afora"
              value={item.value}
              disabled={disableAll}
            />
            <p className="ml-1 font-bold">{item.label}</p>
          </label>
        );
      })}
      <p className="text-base font-bold">
        4.Δεν έχω καταδικαστεί αμετάκλητα για λιποταξία ή ανυποταξία.
      </p>

      <br></br>
      <div className="flex flex-col pt-5">
        {errors["read_dilosi_idiotiton"] &&
          touched["read_dilosi_idiotiton"] && (
            <FormHelperText className="text-xl text-error border-l-2 border-error pl-1">
              {errors["read_dilosi_idiotiton"]}
            </FormHelperText>
          )}
        <div className="flex items-center">
          <p className="text-lg font-bold">
            Έχω διαβάσει και δηλώνω υπεύθυνα τα παραπάνω
          </p>

          <Field
            component={Checkbox}
            type="checkbox"
            name="read_dilosi_idiotiton"
            disabled={disableAll}
          />
        </div>
      </div>
    </div>
  );
};

export default ResignNauticalBlueText;
